// third-party
import { createSlice } from '@reduxjs/toolkit';

// types
import { DefaultRootStateProps } from 'types';
import { ActivityType } from "../../types/type/activities-types";
import {format} from "date-fns";

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['activity'] = {
    error: null,
    activity: [],
    lastConsolidate: [],
    externalActivity: undefined
};

const activity = createSlice({
    name: 'activity',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        //GET ALL ACTIVITIES
        getLastConsolidate(state, action) {
            state.lastConsolidate = action.payload;
        },

        //GET ALL ACTIVITIES
        getAllActivities(state, action) {
            state.activity = action.payload;
        },

        //INSERT NEW ACTIVITY
        insertNewActivity(state, action) {
            state.activity.push(action.payload);
        },

        //UPDATE ACTIVITY
        updateActivity(state, action) {
            state.activity = state.activity.map((el: ActivityType) => {
                if (el.id == action.payload.id) {
                    el = action.payload
                }
                return el
            })
        },

        //DELETE ACTIVITY
        deleteActivity(state, action) {
            state.activity = state.activity.filter((el: ActivityType) => el.id != action.payload.toString());
        },

        //UPDATE CONFIRM ACTIVITY
        updateConfirmActivity(state, action) {
            state.activity = state.activity.map((el: ActivityType) => {
                if (el.id == action.payload.id) {
                    el.act_status = action.payload.act_status
                }
                return el
            })
        },

        //UPDATE CONFIRM ACTIVITY ALL
        updateConfirmAllActivityByDate(state, action) {
            state.activity = state.activity.map((el: ActivityType) => {
                if (el.act_status === 0 && format(new Date(el.start_date), 'yyyy-MM-dd') === action.payload.date) {
                    el.act_status = 1
                }
                return el
            })
        },

        //UPDATE ABSENCE ACTIVITY
        updateAbsenceActivity(state, action) {
            state.activity = state.activity.map((el: ActivityType) => {
                if (el.id == action.payload.id) {
                    el.attendance = action.payload.attendance
                    el.act_status = 1
                }
                return el
            })
        },
        //GET EXTERNAL ACTIVITY
        getExternalActivity(state, action) {
            state.externalActivity = action.payload;
        },

        //UPDATE EXTERNAL ACTIVITY
        updateExternalActivity(state, action) {
            if (state.externalActivity) {
                state.externalActivity.act_status = action.payload
            }
        },
    }
});

// Reducer
export default activity;

// ----------------------------------------------------------------------